// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";

import { mdiFolderPlus } from "@mdi/js";

import { ShapefileAction } from "../..";

interface IShapefileFolderAddActionProps {
  addFolder: () => void;
  setPopoverOpen?: (isOpen: boolean) => void;
  isDisabled?: boolean;
}

export function ShapefileFolderAddAction({
  addFolder,
  setPopoverOpen,
  isDisabled
}: IShapefileFolderAddActionProps) {
  return (
    <ShapefileAction
      disabled={isDisabled}
      placement="bottom"
      onClick={(evt) => {
        addFolder();
        setPopoverOpen && setPopoverOpen(false);
        evt.stopPropagation();
        evt.preventDefault();
      }}>
      <Icon path={mdiFolderPlus} size={"18px"} />
      Add Folder
    </ShapefileAction>
  );
}
